import styled from 'styled-components';
import { Image as ImageBase } from '@hamrolt/components';
import { useDocument } from '../hooks/useDocument';
import { FileData, fileDefaultData } from '../hooks/useFile';
import { DocumentReference } from '../firebase';
import { Section } from './Section';

interface LocalizedData {
	heading: string;
	bodyHTML: string;
}

const defaultLocalizedData: LocalizedData = {
	heading: '',
	bodyHTML: ''
};

interface CommonData {
	published: boolean;
	image: FileData;
}

const defaultCommonData: CommonData = {
	published: false,
	image: fileDefaultData
};

interface Props {
	res: {
		base: DocumentReference;
		localized: DocumentReference;
	};
	className?: string;
}

const Image = styled(ImageBase)`
	grid-area: image;
	display: block;
	width: 100%;
`;

const RichText = styled.div`
	grid-area: text;
	${({ theme }) => theme.richtext};
`;

const Container = styled.div`
	display: grid;
	grid-gap: 24px;
	grid-template-columns: 1fr 1fr;
	grid-template-areas: "image text";
	padding-top: 104px;
`;

export const Accost = ({ res, className }: Props) => {
	const { data: common } = useDocument<CommonData>(res.base, defaultCommonData);
	const { data: localized } = useDocument<LocalizedData>(res.localized, defaultLocalizedData);

	return <Container id="co-u-ciebie" className={className}>
		<Section heading={localized.heading}>
			<RichText dangerouslySetInnerHTML={{ __html: localized.bodyHTML }} />
		</Section>
		<Image src={common.image.url} />
	</Container>
}